// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"e7f221a1","355":"e7f221a1"}[chunkId] + ".chunk.css";
};